module.exports = __webpack_public_path__ + "static/media/33.fcab71c7.png";